import { IView } from './iview';


export interface IViewState {
    view: IView,
    views: Array<IView>,
    error?: any
}
